<template>
  <div>
    <v-toolbar color="highlight" dark dense flat class="sticky mt-5">
      <v-toolbar-title>Firelog {{$t('solutions')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
        <template v-slot:activator="{ on }">
          <v-btn color="white" icon v-on="on">
            <v-icon>fa-info-circle</v-icon>
          </v-btn>
        </template>
        <v-sheet flatwidth="600px">
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_firelog_solutions')}}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
      </v-menu>
    </v-toolbar>
    <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''">
      <v-toolbar elevation="1" dark dense color="secondary darken-3">
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          :label="$t('search')"
          @click:clear="search = ''"
        ></v-text-field>
      </v-toolbar>
      <v-card outlined :loading="!items" flat>
        <list-transition tag="v-list" class="v-list--dense v-list--subheader">
          <v-divider></v-divider>
          <template v-for="(item, i) in filteredItems">
            <div :key="i">
            <v-list-item two-line dense>
              <v-list-item-avatar tile size="40" mr-5>
                <v-img v-if="item.image" :src="item.image"></v-img>
                <img width="40" v-else src="@/assets/empty.png" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title style="margin-left: 5px">{{item.name}}</v-list-item-title>
                <v-list-item-subtitle>
                  <a @click="openSolutionDetails(item)">{{$t('viewSolution')}}</a>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-checkbox
                  :label="$t('active')"
                  v-model="item.published"
                  @change="hidePIMSolution(item)"
                  class="mr-5"
                ></v-checkbox>
              </v-list-item-action>
            </v-list-item>
            </div>
          </template>
        </list-transition>
      </v-card>
    </div>

    <v-dialog fullscreen v-model="dialog" transition="slide-x-reverse-transition">
      <pimSolutionDetails
        v-on:close="dialog = false"
        :id="selectedSolutionId"
        :name="selectedSolutionName"
      />
    </v-dialog>
  </div>
</template>

<script>
import pimSolutionDetails from "@/components/pages/solutions/PIMSolutionDetails";
export default {
  components: {
    pimSolutionDetails
  },
  data() {
    return {
      dialog: false,
      items: [],
      searchtable: null,
      search: "",
      headers: [
        {
          text: this.$t("name"),
          value: "name"
        },
        {
          text: this.$t("active"),
          value: "published"
        }
      ],
      selectedSolutionId: null,
      selectedSolutionName: null
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  methods: {
    openSolutionDetails(item) {
      (this.selectedSolutionId = item.id),
        (this.selectedSolutionName = item.name);
      this.$forceUpdate();
      this.dialog = true;
    },
    hidePIMSolution(item) {
      console.log(item);
      if (item.published) {
        this.$http
          .unhidePIMSolution(item.id)
          .then(res => {
            this.$noty.success('<i class="fas fa-check"></i>');
          })
          .catch(err => {
            console.log(err);
            this.$noty.error(this.$t("error"));
          });
      } else {
        this.$http
          .hidePIMSolution(item.id)
          .then(res => {
            this.$noty.success('<i class="fas fa-check"></i>');
          })
          .catch(err => {
            console.log(err);
            this.$noty.error(this.$t("error"));
          });
      }
    }
  },
  created() {
    this.$http
      .getPIMProductSolutions()
      .then(res => {
        this.items = res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/pages/Solutions/PIMSolutions.vue